import Vue from 'vue';
export default Vue.component('ed-spinner', { 
  name: 'ed-spinner', 
  props: { 
    hasMessage: Boolean,
    color: String
  }
});